export default __webpack_public_path__ + "static/media/6.48c1ab49.jpg";